import { Text } from "@prismicio/editor-ui"

interface Props {
  count: number
}

export function MediaLibraryAssetCount(props: Props) {
  const { count } = props

  return <Text variant="bold">{count} items</Text>
}
